/**
 * The small marks the lifeline's views share, so a line and a finding look the same in the
 * map, the Story and the Table: a dot in a line's colour, and the findings rail's marker
 * (triangle: high, diamond: medium or low).
 */
import { LINES } from './lifelineModel'

export function LineDot({ line }) {
  const label = LINES.find(l => l.key === line)?.label || line
  return <span className="ll-dot" data-line={line} style={{ '--ll-c': `var(--ll-${line})` }} role="img" aria-label={`${label} changed`} />
}

export function SevIcon({ tier, size = 14 }) {
  return tier === 'high'
    ? <svg width={size} height={size} viewBox="0 0 14 14" aria-hidden="true"><path d="M7 1.5 L13 12.5 H1 Z" fill="var(--ll-high)" /></svg>
    : <svg width={size} height={size} viewBox="0 0 14 14" aria-hidden="true"><path d="M7 1 L13 7 L7 13 L1 7 Z" fill={tier === 'medium' ? 'var(--ll-medium)' : 'var(--gray-500)'} /></svg>
}
